/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../plugins/vant-demand-import/installComponents.js"
import VanCheckbox from 'vant/es/checkbox'
import 'vant/es/checkbox/style/less'
import '/data/paas/jhjj-microcredit-mobile-new/codecode/vant-extra/style-override/checkbox.css'


import { render, staticRenderFns } from "./checkbox-with-tracking.vue.js?vue&type=template&id=d757589c!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./checkbox-with-tracking.vue?vue&type=template&id=d757589c"
import script from "./checkbox-with-tracking.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./checkbox-with-tracking.vue?vue&type=script&lang=ts&setup=true"
export * from "./checkbox-with-tracking.vue.ts?vue&type=script&lang=ts&setup=true!=!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/index.js??vue-loader-options!./checkbox-with-tracking.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/@rsbuild/plugin-vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanCheckbox})
